/**
 * The mark, inlined rather than loaded as an image.
 *
 * AN <img src="…svg"> RENDERS IN ITS OWN DOCUMENT. `currentColor` inside the
 * file has nothing to inherit from there, so it resolves to black and the
 * mark looked identical in all four palettes — nearly invisible on the dark
 * one. CSS on the <img> element cannot reach inside it. Inlined as JSX, the
 * shapes sit in the page's own tree, so `currentColor` and `--mark-answered`
 * resolve against `.brand-mark` as intended.
 *
 * The file at src/assets/mark.svg is kept for the favicon build; public/mark.svg
 * carries literal hex because a browser tab has no CSS context either.
 *
 * A tile board, which is what the product actually is: four quiet squares and
 * one that has been answered. The game's own geometry rather than a metaphor —
 * the guidance asks for literal over figurative, and that applies to a mark as
 * much as to a sentence. No gradient, no depth, no face: the learners here
 * include teenagers and adults, and SEN products are routinely infantilised.
 */
export default function Mark({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
    >
      <rect x="2" y="2" width="12" height="12" rx="3.5" fill="none" stroke="currentColor" strokeWidth="2.25" />
      <rect x="18" y="2" width="12" height="12" rx="3.5" fill="none" stroke="currentColor" strokeWidth="2.25" />
      <rect x="2" y="18" width="12" height="12" rx="3.5" fill="none" stroke="currentColor" strokeWidth="2.25" />
      <rect
        x="18"
        y="18"
        width="12"
        height="12"
        rx="3.5"
        fill="var(--mark-answered, currentColor)"
        stroke="var(--mark-answered, currentColor)"
        strokeWidth="2.25"
      />
    </svg>
  );
}
